import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`

let api = {
  // 企业分页
  getAllEnterprisePage: `${baseUrl}/enterprise/all/getPage`,

  // 园区企业分页
  getParkEnterprisePage: `${baseUrl}/enterprise/park/getPage`,

  // 园区企业详情
  getParkEnterpriseById: `${baseUrl}/enterprise/park/getById`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/EnterpriseBigData.js